import {spawnSuccessToast, spawnErrorToast} from '@hm/fundamental'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {updateFeaturesMenu} from '../../api/endpoints'
import type {UpdateMenuInputModel} from '../../api/types/featuresMenu'

export const useUpdateMenu = () => {
  const {t} = useTranslation()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (menuItems: UpdateMenuInputModel[]) => {
      await updateFeaturesMenu(menuItems)
    },
    onError: (error: AxiosError<{message: string}>) => {
      const errorMessage = error.response?.data?.message
      if (errorMessage) {
        spawnErrorToast(t('suite.error.updateMenu', {errorMessage}))
      } else {
        spawnErrorToast(t('suite.error.updateMenuUnknown'))
      }
    },
    onSuccess: () => {
      spawnSuccessToast(t('suite.success.updateMenu'))
      void queryClient.invalidateQueries({queryKey: ['featuresMenu']})
    }
  })
}
